/**
 * Config Manager
 * Unified configuration management for all sites
 * Handles selectors, timings, and URLs
 */

const ConfigManager = {
    currentSite: 'genspark',
    currentTab: 'selectors',
    configs: {},

    // Config field definitions per site
    configFields: {
        genspark: {
            selectors: [
                { key: 'promptInput', label: '프롬프트 입력창', desc: '프롬프트를 입력하는 텍스트 영역 (참조 이미지 드롭 대상)' },
                { key: 'generateButton', label: '생성 버튼', desc: '이미지 생성을 시작하는 버튼' },
                { key: 'loadingIndicator', label: '로딩 표시기', desc: '로딩 중일 때 표시되는 요소' },
                { key: 'generatedImage', label: '생성된 이미지', desc: '생성된 이미지 요소' },
                { key: 'errorMessage', label: '에러 메시지', desc: '에러 발생 시 표시되는 요소' }
            ],
            timings: [
                { key: 'typingDelayMin', label: '타이핑 최소 딜레이', desc: '글자 입력 사이 최소 대기시간 (ms)', type: 'number' },
                { key: 'typingDelayMax', label: '타이핑 최대 딜레이', desc: '글자 입력 사이 최대 대기시간 (ms)', type: 'number' },
                { key: 'afterClickDelay', label: '클릭 후 대기', desc: '버튼 클릭 후 대기시간 (ms)', type: 'number' },
                { key: 'pageLoadDelay', label: '페이지 로드 대기', desc: '페이지 이동 후 대기시간 (ms)', type: 'number' },
                { key: 'generationTimeout', label: '생성 타임아웃', desc: '이미지 생성 최대 대기시간 (ms)', type: 'number' },
                { key: 'pollInterval', label: '폴링 간격', desc: '이미지 확인 간격 (ms)', type: 'number' },
                { key: 'delayBetweenTasks', label: '작업 간 대기', desc: '작업 완료 후 다음 작업까지 대기시간 (ms)', type: 'number' },
                { key: 'elementWaitTimeout', label: '요소 대기 타임아웃', desc: 'DOM 요소 찾기 최대 대기시간 (ms)', type: 'number' },
                { key: 'referenceImageLoadDelay', label: '참조 이미지 로드 대기', desc: '참조 이미지 URL 입력 후 대기시간 (ms)', type: 'number' }
            ],
            urls: [
                { key: 'targetUrl', label: '대상 URL', desc: '자동화 시작 시 이동할 URL' },
                { key: 'tabQueryPattern', label: '탭 검색 패턴', desc: '탭을 찾을 때 사용할 URL 패턴' }
            ]
        },
        naver_blog: {
            selectors: [
                { key: 'titleInput', label: '제목 입력', desc: '블로그 제목 입력 필드' },
                { key: 'contentEditor', label: '내용 에디터', desc: '본문 내용 편집기' },
                { key: 'publishButton', label: '발행 버튼', desc: '포스트 발행 버튼' },
                { key: 'successIndicator', label: '성공 표시', desc: '발행 성공 시 표시되는 요소' }
            ],
            timings: [
                { key: 'typingDelayMin', label: '타이핑 최소 딜레이', desc: '글자 입력 사이 최소 대기시간 (ms)', type: 'number' },
                { key: 'typingDelayMax', label: '타이핑 최대 딜레이', desc: '글자 입력 사이 최대 대기시간 (ms)', type: 'number' },
                { key: 'afterClickDelay', label: '클릭 후 대기', desc: '버튼 클릭 후 대기시간 (ms)', type: 'number' },
                { key: 'pageLoadDelay', label: '페이지 로드 대기', desc: '페이지 이동 후 대기시간 (ms)', type: 'number' },
                { key: 'generationTimeout', label: '작업 타임아웃', desc: '작업 최대 대기시간 (ms)', type: 'number' },
                { key: 'pollInterval', label: '폴링 간격', desc: '상태 확인 간격 (ms)', type: 'number' },
                { key: 'delayBetweenTasks', label: '작업 간 대기', desc: '작업 완료 후 다음 작업까지 대기시간 (ms)', type: 'number' },
                { key: 'elementWaitTimeout', label: '요소 대기 타임아웃', desc: 'DOM 요소 찾기 최대 대기시간 (ms)', type: 'number' }
            ],
            urls: [
                { key: 'targetUrl', label: '대상 URL', desc: '자동화 시작 시 이동할 URL' },
                { key: 'tabQueryPattern', label: '탭 검색 패턴', desc: '탭을 찾을 때 사용할 URL 패턴' }
            ]
        },
        suno: {
            selectors: [
                { key: 'promptInput', label: '프롬프트 입력', desc: '음악 프롬프트 입력 필드' },
                { key: 'generateButton', label: '생성 버튼', desc: '음악 생성 버튼' },
                { key: 'loadingIndicator', label: '로딩 표시', desc: '로딩 중 표시 요소' },
                { key: 'generatedAudio', label: '생성된 오디오', desc: '생성된 음악 오디오 요소' }
            ],
            timings: [
                { key: 'typingDelayMin', label: '타이핑 최소 딜레이', desc: '글자 입력 사이 최소 대기시간 (ms)', type: 'number' },
                { key: 'typingDelayMax', label: '타이핑 최대 딜레이', desc: '글자 입력 사이 최대 대기시간 (ms)', type: 'number' },
                { key: 'afterClickDelay', label: '클릭 후 대기', desc: '버튼 클릭 후 대기시간 (ms)', type: 'number' },
                { key: 'pageLoadDelay', label: '페이지 로드 대기', desc: '페이지 이동 후 대기시간 (ms)', type: 'number' },
                { key: 'generationTimeout', label: '생성 타임아웃', desc: '음악 생성 최대 대기시간 (ms)', type: 'number' },
                { key: 'pollInterval', label: '폴링 간격', desc: '상태 확인 간격 (ms)', type: 'number' },
                { key: 'delayBetweenTasks', label: '작업 간 대기', desc: '작업 완료 후 다음 작업까지 대기시간 (ms)', type: 'number' },
                { key: 'elementWaitTimeout', label: '요소 대기 타임아웃', desc: 'DOM 요소 찾기 최대 대기시간 (ms)', type: 'number' }
            ],
            urls: [
                { key: 'targetUrl', label: '대상 URL', desc: '자동화 시작 시 이동할 URL' },
                { key: 'tabQueryPattern', label: '탭 검색 패턴', desc: '탭을 찾을 때 사용할 URL 패턴' }
            ]
        }
    },

    init() {
        this.setupEventListeners();
    },

    setupEventListeners() {
        // Open modal
        document.getElementById('config-btn').addEventListener('click', () => {
            this.openModal();
        });

        // Close modal
        document.getElementById('close-config-modal').addEventListener('click', () => {
            this.closeModal();
        });

        // Close on backdrop click
        document.getElementById('config-modal').addEventListener('click', (e) => {
            if (e.target.id === 'config-modal') {
                this.closeModal();
            }
        });

        // Site tabs
        document.querySelectorAll('.config-site-tab').forEach(tab => {
            tab.addEventListener('click', () => {
                this.switchSite(tab.dataset.site);
            });
        });

        // Config type tabs (selectors/timings/urls)
        document.querySelectorAll('.config-type-tab').forEach(tab => {
            tab.addEventListener('click', () => {
                this.switchTab(tab.dataset.type);
            });
        });

        // Save button
        document.getElementById('save-config').addEventListener('click', () => {
            this.saveConfig();
        });
    },

    async openModal() {
        document.getElementById('config-modal').classList.remove('hidden');
        await this.loadAllConfigs();
        this.renderConfigForm();
    },

    closeModal() {
        document.getElementById('config-modal').classList.add('hidden');
    },

    switchSite(site) {
        this.currentSite = site;

        // Update site tab UI
        document.querySelectorAll('.config-site-tab').forEach(tab => {
            tab.classList.toggle('active', tab.dataset.site === site);
        });

        this.renderConfigForm();
    },

    switchTab(type) {
        this.currentTab = type;

        // Update type tab UI
        document.querySelectorAll('.config-type-tab').forEach(tab => {
            tab.classList.toggle('active', tab.dataset.type === type);
        });

        this.renderConfigForm();
    },

    async loadAllConfigs() {
        if (!window.supabaseClient) {
            this.showStatus('Supabase 연결 필요', 'error');
            return;
        }

        try {
            const data = await window.supabaseClient.rpc('get_all_site_configs');

            // Convert array to object by site
            this.configs = {};
            data.forEach(item => {
                this.configs[item.site] = {
                    selectors: item.selectors || {},
                    timings: item.timings || {},
                    urls: item.urls || {}
                };
            });

            this.showStatus('설정 로드됨', 'success');
        } catch (error) {
            console.error('Failed to load configs:', error);
            this.showStatus('로드 실패: ' + error.message, 'error');
        }
    },

    renderConfigForm() {
        const container = document.getElementById('config-form-container');
        const siteConfig = this.configs[this.currentSite] || { selectors: {}, timings: {}, urls: {} };
        const fields = this.configFields[this.currentSite]?.[this.currentTab] || [];
        const values = siteConfig[this.currentTab] || {};

        let html = '';
        for (const field of fields) {
            const value = values[field.key] || '';
            const inputType = field.type === 'number' ? 'number' : 'text';

            html += `
                <div class="form-group">
                    <label for="cfg-${field.key}">${field.label}</label>
                    <input type="${inputType}" id="cfg-${field.key}" data-key="${field.key}" value="${this.escapeHtml(String(value))}" placeholder="${field.desc}">
                    <small>${field.desc}</small>
                </div>
            `;
        }

        container.innerHTML = html || '<p class="empty-state">설정 항목이 없습니다</p>';
    },

    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    },

    async saveConfig() {
        if (!window.supabaseClient) {
            this.showStatus('Supabase 연결 필요', 'error');
            return;
        }

        // Collect values from form
        const newValues = {};
        const fields = this.configFields[this.currentSite]?.[this.currentTab] || [];

        for (const field of fields) {
            const input = document.getElementById(`cfg-${field.key}`);
            if (input) {
                let value = input.value.trim();
                // Convert to number if needed
                if (field.type === 'number' && value) {
                    value = parseInt(value, 10);
                }
                if (value !== '' && value !== 0) {
                    newValues[field.key] = value;
                }
            }
        }

        try {
            this.showStatus('저장 중...', 'info');

            // Build update params based on current tab
            const params = {
                p_site: this.currentSite,
                p_updated_by: 'dashboard'
            };

            if (this.currentTab === 'selectors') {
                params.p_selectors = newValues;
            } else if (this.currentTab === 'timings') {
                params.p_timings = newValues;
            } else if (this.currentTab === 'urls') {
                params.p_urls = newValues;
            }

            await window.supabaseClient.rpc('update_site_config', params);

            // Update local cache
            if (!this.configs[this.currentSite]) {
                this.configs[this.currentSite] = { selectors: {}, timings: {}, urls: {} };
            }
            this.configs[this.currentSite][this.currentTab] = newValues;

            this.showStatus('저장 완료!', 'success');

            // Clear status after 3 seconds
            setTimeout(() => {
                this.showStatus('', '');
            }, 3000);

        } catch (error) {
            console.error('Failed to save config:', error);
            this.showStatus('저장 실패: ' + error.message, 'error');
        }
    },

    showStatus(message, type) {
        const statusEl = document.getElementById('config-status');
        statusEl.textContent = message;
        statusEl.className = 'status-text';
        if (type) {
            statusEl.classList.add(`status-${type}`);
        }
    }
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    ConfigManager.init();
});
